import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';



export const searchIncrementalReqLogs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/incremental-req-logs/`, data)
        return await response.data.data
    } catch (error) {
        console.log("searchIncrementalReqLogs - error", error)
        return handleApiError(error)
    }
}

export const insertIncrementalReqLog = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/incremental-req-logs/create`, data)
        return response.data
    } catch (error) {
        console.log("insertIncrementalReqLog - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogById = async (incrementalReqLogId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/incremental-req-logs/${incrementalReqLogId}`)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogById - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogsByIds = async (incrementalReqLogIds) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/incremental-req-logs/incremental-req-log-ids`, incrementalReqLogIds)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogsByIds - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogsByClientPONums = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/incremental-req-logs/client-po-nums`, data)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogsByClientPONums - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogsByReqDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/incremental-req-logs/get-log-by-doc-no/${docNo}`)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogsByReqDocNo - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogsByBuyerReqDocNos = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/incremental-req-logs/buyer-req-doc-nos`, data)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogsByBuyerReqDocNos - error", error)
        return handleApiError(error)
    }
}

export const getIncrementalReqLogByBuyerReqId = async (buyerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/incremental-req-logs/get-log-by-buyer-req-id/${buyerReqId}`)
        return await response.data
    } catch (error) {
        console.log("getIncrementalReqLogByBuyerReqId - error", error)
        return handleApiError(error)
    }
}